// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.chat-message[data-v-24661e66] {
  color: #000;
}
.chat__rightPane[data-v-24661e66] {
  min-width: 70%;
  float: right;
}
.user-box[data-v-24661e66] {
  display: inline-block;
  float: right;
  min-width: 70px;
  max-width: 100%;
}
.user-time-text[data-v-24661e66] {
  font-size: 12px;
}
.avatar-img[data-v-24661e66] {
  width: 25px;
}
.speech-bubble[data-v-24661e66] {
  width: 100%;
  position: relative;
  padding: 10px 30px;
  background-color: #fff;
  color: #000;
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.095);
  border-right: 0 !important;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.speech-bubble[data-v-24661e66]:before,
.speech-bubble[data-v-24661e66]:after {
  content: "\\0020";

  position: absolute;
  top: -12px;
  right: 20px;
  z-index: 2;
  width: 0;
  height: 0;
  overflow: hidden;
  border: solid 14px transparent;
  border-top: 0;
  border-bottom-color: #fff;
  display: none;
}
.speech-bubble[data-v-24661e66]:before {
  top: -14px;
  z-index: 1;
  border-bottom-color: inherit;
  display: none;
}
.user_response[data-v-24661e66] {
  font-size: 12px;
  color: #000;
}
.time__stamp[data-v-24661e66] {
  font-size: 10px;
  color: #000;
}
@media all and (min-width: 1900px) {
.user_response[data-v-24661e66] {
    font-size: 14px;
}
.time__stamp[data-v-24661e66] {
    font-size: 12px;
}
}
@media all and (min-width: 2500px) {
.user_response[data-v-24661e66] {
    font-size: 20px;
}
.time__stamp[data-v-24661e66] {
    font-size: 16px;
}
}
@media all and (min-width: 3800px) {
.user_response[data-v-24661e66] {
    font-size: 32px;
}
.time__stamp[data-v-24661e66] {
    font-size: 20px;
}
}
span.user__icon__box svg[data-v-24661e66] {
  height: 15px;
  width: 15px;
  vertical-align: text-bottom;
}
`, "",{"version":3,"sources":["webpack://./src/components/ChatWidget/UserTextResponse/UserTextResponse.vue"],"names":[],"mappings":";AAkDA;EACE,WAAW;AACb;AAEA;EACE,cAAc;EACd,YAAY;AACd;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AAEA;EACE,eAAe;AACjB;AAEA;EACE,WAAW;AACb;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,wBAAwB;EACxB,2BAA2B;EAC3B,mBAAmB;EACnB,sCAAsC;EACtC,0BAA0B;EAC1B,0BAA0B;EAC1B,6BAA6B;AAC/B;AAEA;;EAEE,gBAAgB;;EAEhB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,8BAA8B;EAC9B,aAAa;EACb,yBAAyB;EACzB,aAAa;AACf;AAEA;EACE,UAAU;EACV,UAAU;EACV,4BAA4B;EAC5B,aAAa;AACf;AAEA;EACE,eAAe;EACf,WAAW;AACb;AAEA;EACE,eAAe;EACf,WAAW;AACb;AAEA;AACE;IACE,eAAe;AACjB;AAEA;IACE,eAAe;AACjB;AACF;AAEA;AACE;IACE,eAAe;AACjB;AAEA;IACE,eAAe;AACjB;AACF;AAEA;AACE;IACE,eAAe;AACjB;AAEA;IACE,eAAe;AACjB;AACF;AAEA;EACE,YAAY;EACZ,WAAW;EACX,2BAA2B;AAC7B","sourcesContent":["<!--\r\nImportant:\r\nThis file is used only in vue3 applications\r\nChanges made here should be made in he vue2 also\r\nfile Location: wwwroot\\js\\components\\shared\\ChatWidget\\usertextresponse\\usertextresponse.vue\r\nFor Clarifications contact Leela\r\n-->\r\n<template>\r\n  <div>\r\n    <template v-if=\"userinput.UserResponse || userinput.EventLabel\">\r\n      <div class=\"out my-2\" :id=\"'userResponse' + index\">\r\n        <div class=\"chat__rightPane\">\r\n          <small class=\"d-block text-left mb-1 pl-3 grey-text time__stamp user-time-text\">\r\n            <span class=\"user__icon__box\">\r\n              <svg :fill=\"chatThemeSettings?.borderColor || '#B3B3B3'\" xmlns=\"http://www.w3.org/2000/svg\"\r\n                viewBox=\"0 0 24 24\" width=\"24\" height=\"24\">\r\n                <path fill=\"none\" d=\"M0 0h24v24H0z\" />\r\n                <path\r\n                  d=\"M4 22a8 8 0 1 1 16 0h-2a6 6 0 1 0-12 0H4zm8-9c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4z\" />\r\n              </svg>\r\n            </span>\r\n            <span v-html=\"userinput.FromUser === 'user' ? 'You' : userinput.FromUser\" />\r\n            {{ requesttime }}\r\n          </small>\r\n          <div class=\"chat-body speech-bubble mb-1 flex-fill position-relative user-box\"\r\n            style=\"border: 1px solid #007cc329\" :style=\"{ borderColor: chatThemeSettings?.borderColor }\">\r\n            <div class=\"chat-message\">\r\n              <div>\r\n                <p v-if=\"userinput.customUIUserResponse\" class=\"user_response mb-0\">\r\n                  {{\r\n                    userinput.customUIUserResponse\r\n                      ? userinput.customUIUserResponse\r\n                      : userinput.EventLabel\r\n                  }}\r\n                </p>\r\n                <p v-else class=\"user_response mb-0\">\r\n                  {{ userinput.UserResponse ? userinput.UserResponse : userinput.EventLabel }}\r\n                </p>\r\n              </div>\r\n            </div>\r\n            <div style=\"clear: both\"></div>\r\n          </div>\r\n        </div>\r\n        <div style=\"clear: both\"></div>\r\n      </div>\r\n    </template>\r\n  </div>\r\n</template>\r\n<script src=\"./UserTextResponse.js\"></script>\r\n<style scoped>\r\n.chat-message {\r\n  color: #000;\r\n}\r\n\r\n.chat__rightPane {\r\n  min-width: 70%;\r\n  float: right;\r\n}\r\n\r\n.user-box {\r\n  display: inline-block;\r\n  float: right;\r\n  min-width: 70px;\r\n  max-width: 100%;\r\n}\r\n\r\n.user-time-text {\r\n  font-size: 12px;\r\n}\r\n\r\n.avatar-img {\r\n  width: 25px;\r\n}\r\n\r\n.speech-bubble {\r\n  width: 100%;\r\n  position: relative;\r\n  padding: 10px 30px;\r\n  background-color: #fff;\r\n  color: #000;\r\n  -moz-border-radius: 10px;\r\n  -webkit-border-radius: 10px;\r\n  border-radius: 10px;\r\n  border: 1px solid rgba(0, 0, 0, 0.095);\r\n  border-right: 0 !important;\r\n  border-top-right-radius: 0;\r\n  border-bottom-right-radius: 0;\r\n}\r\n\r\n.speech-bubble:before,\r\n.speech-bubble:after {\r\n  content: \"\\0020\";\r\n\r\n  position: absolute;\r\n  top: -12px;\r\n  right: 20px;\r\n  z-index: 2;\r\n  width: 0;\r\n  height: 0;\r\n  overflow: hidden;\r\n  border: solid 14px transparent;\r\n  border-top: 0;\r\n  border-bottom-color: #fff;\r\n  display: none;\r\n}\r\n\r\n.speech-bubble:before {\r\n  top: -14px;\r\n  z-index: 1;\r\n  border-bottom-color: inherit;\r\n  display: none;\r\n}\r\n\r\n.user_response {\r\n  font-size: 12px;\r\n  color: #000;\r\n}\r\n\r\n.time__stamp {\r\n  font-size: 10px;\r\n  color: #000;\r\n}\r\n\r\n@media all and (min-width: 1900px) {\r\n  .user_response {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .time__stamp {\r\n    font-size: 12px;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 2500px) {\r\n  .user_response {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .time__stamp {\r\n    font-size: 16px;\r\n  }\r\n}\r\n\r\n@media all and (min-width: 3800px) {\r\n  .user_response {\r\n    font-size: 32px;\r\n  }\r\n\r\n  .time__stamp {\r\n    font-size: 20px;\r\n  }\r\n}\r\n\r\nspan.user__icon__box svg {\r\n  height: 15px;\r\n  width: 15px;\r\n  vertical-align: text-bottom;\r\n}\r\n</style>\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
